import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core';

@Component({
  selector: 'privacy-and-terms',
  template: require('./privacy-and-terms.component.html'),
  styles: [require('./privacy-and-terms.component.scss')],
})
export class PrivacyAndTermsComponent implements AfterViewInit {
  @ViewChild('textContainer') textContainer: ElementRef;
  @HostListener('window:scroll', ['$event'])
  file: string = 'Privacy Policy';
  privacyText: string = require('./privacy-policy-file.html');
  termsText: string = require('./terms-and-conditions-file.html');
  fileText: string = require('./privacy-policy-file.html');
  displayBoxShadow: boolean = false;
  loaded: boolean = false;

  constructor(private el: ElementRef) {
    //
  }

  ngAfterViewInit(): boolean {
    return (this.loaded = true);
  }

  onSelect(selectedFile: string): void {
    selectedFile === 'Privacy Policy' ? (this.fileText = this.privacyText) : (this.fileText = this.termsText);
    this.file = selectedFile;
  }

  isActive(stateName: string): boolean {
    return this.file === stateName;
  }

  onWindowScroll(e: object): void {
    let scrollTop = this.textContainer.nativeElement.scrollTop;
    scrollTop > 10 ? (this.displayBoxShadow = true) : (this.displayBoxShadow = false);
  }
}
